import { UrlMatchResult, UrlSegment } from '@angular/router';

export function galleryUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length > 0) {
    if (segments[0].path === 'gallery') {
      const path = new UrlSegment(segments.slice(1).join('/'), {});
      return {
        consumed: segments,
        posParams: {path},
      };
    }
  }
  return null;
}
